import React from "react"

import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUserPlus } from "@fortawesome/free-solid-svg-icons"
import ProjectCollaborate from "../../invite/ProjectCollaborate"

class InviteCollaborators extends React.Component{
    render(){
        const { id } = this.props
        return(
            <div className="manageSection" id="inviteCollaborators">
                <div className="manageHeader">
                    <div className="svgContainer">
                        <FontAwesomeIcon icon={faUserPlus} />
                    </div>
                    <div className="introText">
                        <h1 className="headerTitle">Invite Collaborators</h1>
                        <p>Set your project to <b>private</b>, and invite your friends to collaborate your game!<br />
                        Collaborators can request a build.
                            (Your friends have to be <Link to="/invite">invited</Link> to the platform first)</p>
                    </div>
                </div>
                <ProjectCollaborate id={id}/>
            </div>
        )
    }
}

export default InviteCollaborators